import { InjectionToken, Provider } from '@angular/core';
import { CampaignsOffersApiService } from './campaigns-offers-api.service';
import { CampaignsOffersRepository } from './campaigns-offers.repository';

export const HTTP_CAMPAIGNS_OFFERS_SERVICE = new InjectionToken<CampaignsOffersRepository>('CampaignsOffersRepository');

export const CAMPAIGNS_OFFERS_API_PROVIDER: Provider = {
    provide: HTTP_CAMPAIGNS_OFFERS_SERVICE,
    useClass: CampaignsOffersApiService,
};
